import React, { useEffect, useState } from 'react'
import { Location } from '@reach/router'
import { Link } from 'gatsby'
import { Menu, X } from 'react-feather'
import Logo from './Logo'

import './Nav.css'

/* eslint-disable */

export const Navigation = ({ subNav, location }) => {
  const [active, setActive] = useState(false)
  const [activeSubNav, setActiveSubNav] = useState(false)
  const [currentPath, setCurrentPath] = useState(false)

  useEffect(() => {
    setCurrentPath(location.pathname)
  }, [])

  const handleMenuToggle = () => setActive(!active)

  // Only close nav if it is open
  const handleLinkClick = () => active && handleMenuToggle()

  const toggleSubNav = subNav =>
    setActiveSubNav(activeSubNav === subNav ? false : subNav)

  const NavLink = ({ to, className, children, ...props }) => (
    <Link
      to={to}
      className={`NavLink ${to === currentPath ? 'active' : ''} ${className}`}
      onClick={() => handleLinkClick()}
      {...props}
    >
      {children}
    </Link>
  )

  return (
    <nav className={`Nav ${active ? 'Nav-active' : ''}`}>
      <div
        className={
          currentPath === '/'
            ? `Nav--Container container border`
            : `Nav--Container container`
        }
      >
        <Link to="/" onClick={() => handleLinkClick()}>
          <Logo />
        </Link>
        <div className="Nav--Links">
          <NavLink to="/brand-design/">Brand Design</NavLink>
          <NavLink to="/ui-ux/">UI/UX</NavLink>
          <NavLink to="/graphic-design/">Graphic Design</NavLink>
          <NavLink to="/project-reel/">Project Reel</NavLink>
          <NavLink to="/people/">People</NavLink>
          <NavLink to="/support/">Support</NavLink>
        </div>
        <button
          className="Button-blank Nav--MenuButton"
          onClick={() => handleMenuToggle()}
        >
          {active ? <X size={36} /> : <Menu size={36} />}
        </button>
      </div>
    </nav>
  )
}

export default ({ subNav }) => (
  <Location>{route => <Navigation subNav={subNav} {...route} />}</Location>
)
